<template>
  <div class="row">
   <div class="col-48 gx-5 singleMap">
     <GMapMap
      :center="{lat: -31.92998972353236, lng: 115.85853883219353}"
      :zoom="4"
      :options="mapStyle"
  >
    <GMapCluster :zoomOnClick="true" :styles="clusterStyles">
          
      <GMapMarker
        :key="index"
        v-for="(m, index) in items"
        :position="{lat:Number(m.newlat),lng: Number(m.newlng )}"
        :clickable="true"
        :draggable="true"
        :icon="getMarkers(index)"
        @click="toggleInfoWindow(m,index)"
        :id="m.id"
        ref="marker"
      >
     
    </GMapMarker>
     <GMapInfoWindow
        :options="infoOptions " :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false"
      >
        <div class="info-window">
                        <p class="mb-0"><b>{{infoContent.name}}</b></p>
                        <p class="mb-2">Phone: {{infoContent.phone}}</p>
                       <p style="font-size:14px;" class="mb-0" v-if="infoContent.slug">  <router-link  class="" :to="{name: 'SingleService', params: { title: infoContent.slug } }">
          View Service
          </router-link><br></p>
                         <a target="_blank" style="font-size:14px;" :href="`https://maps.google.com/maps?daddr=${infoContent.address}`">Get Directions <span class="screen-reader-only">(opens in a new tab)</span></a>
                      </div>
      </GMapInfoWindow>
        </GMapCluster>


  </GMapMap>

    </div>

  </div>
</template>

<script>

export default {
name: 'GoogleMap',
props: ['items'],
data () {
    let mapMarker ='https://wanada.org.au/wp-content/themes/wanada-child/img/marker.png';
   
      return {
   mapMarker,
     
     markers: [],
      zoom: 8,
      infoContent: '',
     selectedKey:'',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      positionCalc:'',
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
         center: {lat: -31.92998972353236, lng: 115.85853883219353},
         mapStyle: {
         draggable:true,
           zoomControl: false,
           mapTypeControl: false,
           scaleControl: false,
           streetViewControl: false,
           rotateControl: false,
           fullscreenControl: false,
           animation: 2,
           disableDefaultUI: true,
           styles: [{featureType: "water",elementType: "geometry",stylers: [{color: "#e9e9e9"},{lightness: 17 } ] }, { featureType: "landscape", elementType: "geometry", stylers: [ { color: "#f5f5f5" }, { lightness: 20 } ] }, { featureType: "road.highway", elementType: "geometry.fill", stylers: [ { color: "#ffffff" }, { lightness: 17 } ] }, { featureType: "road.highway", elementType: "geometry.stroke", stylers: [ { color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 } ] }, { featureType: "road.arterial", elementType: "geometry", stylers: [ { color: "#ffffff" }, { lightness: 18 } ] }, { featureType: "road.local", elementType: "geometry", stylers: [ { color: "#ffffff" }, { lightness: 16 } ] }, { featureType: "poi", elementType: "geometry", stylers: [ { color: "#f5f5f5" }, { lightness: 21 } ] }, { featureType: "poi.park", elementType: "geometry", stylers: [ { color: "#dedede" }, { lightness: 21 } ] }, { elementType: "labels.text.stroke", stylers: [ { visibility: "on" }, { color: "#ffffff" }, { lightness: 16 } ] }, { elementType: "labels.text.fill", stylers: [ { saturation: 36 }, { color: "#333333" }, { lightness: 40 } ] }, { elementType: "labels.icon", stylers: [ { visibility: "off" } ] }, { featureType: "transit", elementType: "geometry", stylers: [ { color: "#f2f2f2" }, { lightness: 19 } ] }, { featureType: "administrative", elementType: "geometry.fill", stylers: [ { color: "#fefefe" }, { lightness: 20 } ] }, { featureType: "administrative", elementType: "geometry.stroke", stylers: [ { color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 } ] } ]        
      },
       clusterStyles: [
        {
          textColor: 'black',
          url:'https://wanada.org.au/wp-content/themes/wanada-child/img/lgreen.png',
          height: 52,
          width: 53
        },
        {
          textColor: 'white',
          url: 'https://wanada.org.au/wp-content/themes/wanada-child/img/dgreen.png',
          height: 52,
          width: 53
        },
        {
          textColor: 'white',
          url: 'https://wanada.org.au/wp-content/themes/wanada-child/img/dgreen.png',
          height: 52,
          width: 53
        }
      ],
 
 }
 },
         methods: {
 getMarkers(index) {
      if (this.selectedKey === index) return this.mapMarkerActive;
      return this.mapMarker;
    },
        
         toggleInfoWindow ( service, idx ) {
           //console.log('clicked');
         this.infoWindowPos = {lat:Number(service.newlat),lng: Number(service.newlng )},
          this.infoContent = {name: service.name,
                  phone: service.phone1,
                  address: service.street +', '+ service.suburb +'+'+ service.postcode,
                  slug: service.slug}
                  // console.log(this.infoContent)
          if ( this.currentMidx === idx ) {
            this.infoWinOpen = !this.infoWinOpen
          }
          else {
            this.infoWinOpen = true
            this.currentMidx = idx
          }
        },


    say(service) {
     this.$refs.mapRef.$mapPromise.then((map) => {
      this.zoom = 8;
        map.panTo(service)
            this.infoWinOpen = true
    })

  }

        },
}
</script>

<style lang="scss">
// @import '@/assets/app.scss';
</style>
